import React from "react";
import "./style.css";

const CustomModal = ({
  show,
  onClose,
  title,
  children,
  footer,
  size = "default",
  bodyClassName = ""
}) => {
  if (!show) return null; // don't render if modal is closed

  return (
    <div className="custom-modal-overlay">
      <div className={`custom-modal custom-modal--${size}`}>
        {/* Header */}
        <div className="custom-modal-header">
          <h5>{title}</h5>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        {/* Body */}
        <div className={`custom-modal-body ${bodyClassName}`}>
          {children}
        </div>

        {/* Footer */}
        {footer && (
          <div className="custom-modal-footer">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomModal;
